import { render, staticRenderFns } from "./PosView.vue?vue&type=template&id=6ec67967&scoped=true"
import script from "./PosView.vue?vue&type=script&lang=js"
export * from "./PosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec67967",
  null
  
)

export default component.exports